module.exports = __webpack_public_path__ + "img/20220805141244.544f32c9.jpg";